// src/pages/clubs/ClubBroadcast.jsx
//
// LEGACY-COMPAT REDIRECT (May-2026).
//
// The old standalone ClubBroadcast wizard was folded into the modern
// ComposerWizard (Path A in the club-composer migration). The /broadcast
// URL is preserved because the sidebar nav, marketing emails, and Sprint A
// docs all link to it — but instead of mounting the old page we forward
// to /clubs/:clubId/messages/new, which is the canonical club composer
// route registered in App.jsx.
//
// All forwarded URL params (?type=, ?audience=, ?seasonId=, ?teams=,
// ?programId=, etc.) flow through to the composer untouched, so any deep
// link that worked against the old page keeps working.
//
// Removing this file is safe once the sidebar + outbound links migrate
// to the new URL.
import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';

export default function ClubBroadcast() {
  const { clubId } = useParams();
  const { search } = useLocation();
  return (
    <Navigate
      to={`/clubs/${clubId}/messages/new${search || ''}`}
      replace
    />
  );
}
